import { ISerpApiSearchResult } from "../models/PartLookup";

export interface IIntelligencePriceSummary {
  min: number;
  max: number;
  avg: number;
}

/**
 * Min, max and mean asking price of the eBay listings Wilma Intelligence returned, rounded to the
 * penny. Listings without a positive price are ignored; null when none are left. Matches the API's
 * IntelligencePriceSummary, which stores the same figures on the part.
 */
export function summarisePrices(
  results: ISerpApiSearchResult[] | null | undefined,
): IIntelligencePriceSummary | null {
  const prices = (results ?? [])
    .map((r) => r.priceExtracted)
    .filter((p): p is number => p != null && p > 0);

  if (prices.length === 0) return null;

  const round = (n: number) => Math.round(n * 100) / 100;

  return {
    min: round(Math.min(...prices)),
    max: round(Math.max(...prices)),
    avg: round(prices.reduce((sum, p) => sum + p, 0) / prices.length),
  };
}
